var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":_vm.url}},[_c('div',{class:_vm.classes,style:(_vm.styles)}),_vm._v(" "),_c('h3',[_vm._v("\n    "+_vm._s(_vm.nominee.name)+" "),_c('br'),_vm._v("\n    "+_vm._s(_vm.nominee.stations[0])+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-914b5552","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NomineeItem.vue
// module id = null
// module chunks = 